<rt-badge [color]="badgeColor()" [text]="label()" />
